export default __webpack_public_path__ + "static/media/spaced-background-1.fa327c66.png";